/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
/* eslint-disable max-lines */
define(function (require, exports, module) {
    'use strict';

    const app = require('Cloud/Application/app');
    const { path: rPath, isNil } = require('ramda');
    const _ = require('Cloud/Application/_');
    const uploadLog = require('./uploadLog');
    const uploadRadar = require('./uploadRadar');
    const UploadDescriptor = require('./UploadDescriptor');
    const UploadDataSource = require('./UploadDataSource');
    const UploadReason = require('./UploadReason');
    const UploadCancel = require('./UploadCancel');
    const UploadError = require('./errors/UploadError');
    const ConnectionFail = require('./fails/ConnectionFail');
    const OverQuotaFail = require('./fails/OverQuotaFail');
    const UserFileSizeLimitFail = require('./fails/UserFileSizeLimitFail');
    const FileTooLargeError = require('./errors/FileTooLargeError');
    const FileExistsFail = require('./fails/FileExistsFail');
    const ReadOnlyDirectoryFail = require('./fails/ReadOnlyDirectoryFail');
    const NameTooLongFail = require('./fails/NameTooLongFail');
    const PublicFileSizeLimitFail = require('./fails/PublicFileSizeLimit');
    const PathTooLongFail = require('./fails/PathTooLongFail');
    const InvalidCharactesFail = require('./fails/InvalidCharactesFail');
    const requestMicrotask = require('./tools/async/requestMicrotask');
    const AsyncIterator = require('./tools/async/AsyncIterator');
    const cloudFileSystem = require('./tools/cloud/cloudFileSystem');
    const cloudFileSystemPath = require('./tools/cloud/cloudFileSystemPath');
    const fileSystemPath = require('./tools/fs/fileSystemPath');
    const fileSystemFileHelper = require('./tools/fs/fileSystemFileHelper');
    const fileSystemEntryHelper = require('./tools/fs/fileSystemEntryHelper');
    const DropArea = require('./tools/dnd/DropArea');
    const { requestPayment } = require('Cloud/Application/Payment');
    const config = require('Cloud/config');
    const { UploadDropAreaToolkit } = require('reactApp/ui/UploadDropArea/UploadDropAreaToolkit');
    const { getOpenState } = require('reactApp/ui/UploadDropArea/UploadDropArea');
    const { showcaseController } = require('reactApp/ui/Showcase/Showcase.controller');
    const { openInNewTab } = require('reactApp/appHelpers/appHelpers');
    const { publishHelper } = require('reactApp/appHelpers/publishHelper');
    const { EStorageType } = require('reactApp/modules/storage/storage.types');
    const { openViewer } = require('reactApp/modules/viewer/viewer.module');
    const { bytesToNDigits } = require('@mail/cross-sizes-utils');
    const { uploaderTotalProgress, setButtonTypeClickAction, setUploadFromAction } = require('reactApp/modules/upload/upload.module');
    const { selectButtonTypeClick } = require('reactApp/modules/upload/upload.selectors');
    const { ViewerSelectors } = require('reactApp/modules/viewer/viewer.selectors');
    const { getCurrentFolder } = require('reactApp/modules/storage/storage.selectors');
    const { IS_PUBLIC_ALBUM } = require('reactApp/appHelpers/configHelpers');
    const { isEmailAbsent } = require('reactApp/modules/socialUser/socialUser.selectors');
    const {
        setInputFilesAction,
        updateUploadFilesAction,
        setHasInputAction,
        setProgressStatusAction,
    } = require('reactApp/modules/uploadList/uploadList.module');
    const {
        renderSelectAnotherFolderDialog,
        renderSelectUploadFolderDialog,
    } = require('reactApp/ui/SelectFolderDialog/SelectFolderDialog.toolkit');
    const {
        askUserForConflict,
        askUserForPayment,
        waitForCreateFolderIfNotExists,
    } = require('reactApp/modules/uploadList/oldUploadListBridge');
    const { EProgressStatus, EFileError, EFileStatus } = require('/reactApp/modules/uploadList/uploadList.model');
    const { isUploaderVisible } = require('reactApp/modules/uploadList/uploadList.selectors');

    const { renderUploadFromClipboardDialog } = require('reactApp/ui/NoWarningDialog/NoWarningDialog.helpers');
    const { getUploadAlbumId } = require('reactApp/modules/albums/albums.selector');
    const { store: reduxStore } = require('reactApp/store');
    const { snackbarController } = require('reactApp/modules/snackbar/snackbar.controller');
    const { SnackbarTypes } = require('reactApp/modules/snackbar/snackbar.types');
    const { sendDatalistGa } = require('reactApp/utils/datalistGa');
    const { openPopupHelper } = require('reactApp/modules/popup/popup.helpers');
    const { popupNames } = require('reactApp/modules/popup/popup.types');
    const { UserSelectors } = require('reactApp/modules/user/user.selectors');
    const { sendNewUserGa } = require('reactApp/utils/newUserGa');
    const { sendTmrGoal } = require('reactApp/utils/tmr');
    const { sendGaUploader } = require('reactApp/modules/uploadList/uploadList.helpers');
    const { PERSONAL_DOCUMENTS_FOLDER_NAME } = require('reactApp/modules/personalDocuments/personalDocuments.constants');
    const { uploadDescriptor } = require('reactApp/modules/uploadList/uploadList.module');
    const { mapStorageToFolder } = require('reactApp/modules/uploadList/uploadList.constants');
    const { isUploadFolderAllowed } = require('reactApp/modules/upload/upload.selectors');
    const { getCurrentStorage } = require('reactApp/modules/router/router.selectors');
    const { hideUploaderAction } = require('reactApp/modules/upload/upload.module');
    const { roundCustom } = require('reactApp/utils/helpers');
    const { extInfo } = require('lib/extInfo');
    const { getStorage } = require('reactApp/modules/storage/storage.helpers');
    const { getCurrentVisibleDialogId } = require('reactApp/modules/dialog/dialog.selectors');
    const { UPLOAD_DIALOG_ID } = require('reactApp/ui/UploadDialog/UploadDialog.constants');
    const { isWelcomePromoShow } = require('reactApp/modules/welcome/welcome.selectors');
    const { sendXray } = require('reactApp/utils/ga');
    const { ALBUMS_FOLDER_NAME } = require('reactApp/modules/albums/albums.constants');

    const throttle = require('lodash.throttle');
    const { isPublicUploadEnabled, isOwnPublic } = require('reactApp/modules/public/public.selectors');
    const { set: setIndexedDb } = require('idb-keyval');
    const { sizeGroups } = require('reactApp/constants/index');
    const { Spaces } = require('@mail/cross-sizes-utils');
    const { getFileExtLimit } = require('reactApp/utils/textHelpers');

    const IS_WEBVIEW = config.get('IS_WEBVIEW');
    const IS_PHONE = config.get('PHONE_BROWSER');
    const IS_MOBILE = config.get('MOBILE_BROWSER');
    const IS_REACT_PAGE = config.get('REACT_PAGE');
    const IS_PUBLIC = config.get('PUBLIC');
    const PLATFORM = (() => {
        switch (true) {
            case Boolean(IS_WEBVIEW):
                return 'webview';
            case Boolean(IS_PHONE):
                return 'touch';
            case Boolean(IS_MOBILE):
                return 'tablet';
            default:
                return 'desktop';
        }
    })();
    const ENV = IS_PUBLIC ? 'public' : 'private';
    const RETRY_TIMEOUT = 10 * 1000;
    const bigFileSize = 100 * Spaces.ONE_MB;

    const showNotification = ({ text = '', type = SnackbarTypes.failure }) => {
        snackbarController.showSnackbar({ id: 'uploaderror', text, type, closable: true });
    };

    const uploaderTotalProgressThrottled = throttle((item) => {
        reduxStore.dispatch(uploaderTotalProgress(item));
    }, 500);

    // TODO:  пока на реакт страницах грузим все в корень хомяка, если не в хомяке
    const getWorkingDirectory = (originalCloudPath = null) => {
        // при продолжении загрузки используем изначальную директорию
        if (originalCloudPath) {
            return originalCloudPath;
        }
        const storage = getCurrentStorage(reduxStore.getState());
        const currentFolder = getCurrentFolder(reduxStore.getState());
        const { isDocuments, isHome } = getStorage(storage);

        if (isDocuments) {
            return `/${PERSONAL_DOCUMENTS_FOLDER_NAME}`;
        }

        if (storage === EStorageType.albums) {
            return `/${ALBUMS_FOLDER_NAME}`;
        }

        if (IS_REACT_PAGE) {
            if (isHome) {
                return currentFolder.id;
            }

            return '/';
        }

        const folder = getCurrentFolder(reduxStore.getState());

        if (IS_PUBLIC && folder?.home) {
            return folder.home;
        }

        return folder && folder.id;
    };

    /**
     * @constructor
     */
    function UploadController() {
        this.handleEvent = this.handleEvent.bind(this);
        this._uploadNext = this._uploadNext.bind(this);
        this._initDropArea();
        this._initClipboardUpload();
    }

    UploadController.prototype = {
        constructor: UploadController,

        /**
         * @type {UploadDescriptor.List}
         */
        _queue: null,

        /**
         * Отражает активность загрузки.
         * @type {boolean}
         */
        _isActive: false,

        /**
         * @interface {UploadDataSource}
         */
        _dataSource: null,

        /**
         * @type {DropArea}
         */
        _dropArea: null,

        _conflictResolution: null,

        _conflictResolutionReadOnlyFolder: null,

        _folderToUploadFromReactPages: null,

        _lastQueuedDescriptors: [],

        /**
         * @returns {boolean}
         */
        isActive() {
            return this._isActive;
        },

        /**
         *
         */
        clearUploadedQueue() {
            this._destroyDataSource();
            this._destroyQueue();
        },

        /**
         * @returns {boolean}
         */
        _canUpload() {
            const state = reduxStore.getState();
            const isNewbie = app.user.isNewbie();
            const isAuthorized = app.user.isAuthorized();
            const isSocial = app.user.isSocialUser();
            const storageHelper = getStorage(getCurrentStorage(state));
            const isStorageSupportsUpload =
                storageHelper.isStart ||
                storageHelper.isDocuments ||
                storageHelper.isHome ||
                storageHelper.isGallery ||
                storageHelper.isFeed ||
                storageHelper.isFavorites ||
                storageHelper.isAlbums ||
                app.available().add;
            const isOwn = IS_PUBLIC ? isOwnPublic(state) : false;
            const canUploadToPublic = IS_PUBLIC ? isPublicUploadEnabled(state) || isOwn : false;
            const isViewerActive = ViewerSelectors.isViewerActive(state);

            if ((isSocial && isEmailAbsent(state) && !IS_PUBLIC) || isViewerActive || IS_PUBLIC_ALBUM) {
                return false;
            }

            return (IS_PUBLIC || !isNewbie) && isAuthorized && isStorageSupportsUpload && (IS_PUBLIC ? canUploadToPublic : true);
        },

        /**
         * @param {Array.<UploadDescriptor>} descriptors
         * @returns {Promise}
         * @resolves {Array.<UploadDescriptor>}
         * @rejects {Error}
         */
        _filterDescriptors(descriptors) {
            return new Promise((resolve) => {
                const counters = {
                    emptyDirectories: 0,
                    directories: 0,
                    files: 0,
                };

                const result = descriptors.filter((descriptor) => {
                    const isDirectory = descriptor.get('isDirectory');
                    let hasNotChildren;

                    if (isDirectory) {
                        const isFolderAllowed = isUploadFolderAllowed(reduxStore.getState());

                        if (!isFolderAllowed) {
                            return false;
                        }

                        hasNotChildren = !descriptor.get('children').length;

                        if (hasNotChildren) {
                            counters.emptyDirectories++;
                        }

                        counters.directories++;
                    } else {
                        hasNotChildren = true;
                        counters.files++;
                    }

                    // Оставляем только пустые папки и файлы.
                    // Остальные папки будут автоматически
                    // созданы нашим API при добавлении файлов.
                    return hasNotChildren && !(IS_PUBLIC && isDirectory);
                });

                const radar = uploadRadar.create();

                radar.add('enqueue_all', descriptors.length);
                radar.add('enqueue_folders_empty', counters.emptyDirectories);
                radar.add('enqueue_folders_all', counters.directories);
                radar.add('enqueue_files_all', counters.files);
                radar.send();

                resolve(result);
            });
        },

        /**
         * Устанавливает albumId при загрузке в альбом
         * Нужно чтобы запомнить альбом при переходах по страницам
         */
        _setAlbumIdForAlbums(descriptorOptions = {}) {
            const currentAlbumId = getUploadAlbumId(reduxStore.getState());

            if (!currentAlbumId) {
                return;
            }

            descriptorOptions.albumId = currentAlbumId;
        },

        /**
         * @param {Object} data
         * @returns {string}
         */
        _validatePaths({ error, path, onlyPath = false }) {
            let validation;

            if (!error && !onlyPath) {
                validation = cloudFileSystemPath.validateName(path);

                if (validation instanceof UploadReason) {
                    error = validation;
                }
            }

            if (!error) {
                validation = cloudFileSystemPath.validatePath(path);

                if (validation instanceof UploadReason) {
                    error = validation;
                }
            }

            return error;
        },

        /**
         * @param {Error} error
         * @param {string} cloudName
         * @param {string} cloudPath
         * @param {string} localPath
         * @returns object
         */
        _autoFixError({ error, cloudName, cloudPath, localPath }) {
            const maxNameLength = 50;
            let fixCloudName = cloudName;
            let fixCloudPath = cloudPath;
            let fixLocalPath = localPath;
            let fixError = error;
            let hasInvalidCharAutoFix = false;
            let hasNameTooLongAutoFix = false;

            if (error instanceof InvalidCharactesFail) {
                fixCloudName = cloudFileSystemPath.removeInvalidNameCharacters(cloudName);
                fixCloudPath = cloudFileSystemPath.removeInvalidPathCharacters(cloudPath);
                fixLocalPath = cloudFileSystemPath.removeInvalidPathCharacters(localPath);
                fixError = null;
                hasInvalidCharAutoFix = true;
                sendGaUploader('auto_fix', 'invalid_char');
            } else if (error instanceof NameTooLongFail) {
                fixCloudName = `${fixCloudName.slice(0, maxNameLength)}...${fixCloudName.slice(-maxNameLength)}`;
                fixCloudPath = `${fixCloudPath.slice(0, maxNameLength)}...${fixCloudName.slice(-maxNameLength)}`;
                fixLocalPath = `${fixLocalPath.slice(0, maxNameLength)}...${fixLocalPath.slice(-maxNameLength)}`;
                fixError = null;
                hasNameTooLongAutoFix = true;
                sendGaUploader('auto_fix', 'name_too_long');
            }

            return { fixCloudName, fixCloudPath, fixLocalPath, fixError, hasInvalidCharAutoFix, hasNameTooLongAutoFix };
        },

        /**
         * @param {Array.<UploadDescriptor>} descriptors
         * @param {string} workingDirectory
         * @returns {Promise}
         * @resolves {Array.<UploadDescriptor>}
         * @rejects {Error}
         */
        _prepareDescriptors(descriptors, workingDirectory) {
            return new AsyncIterator(descriptors, (descriptor, index, descriptors, next) => {
                const attributes = {};
                const localName = descriptor.get('localName');
                const IS_OWN_PUBLIC = config.get('IS_OWN_PUBLIC');
                let localPath = descriptor.get('localPath');
                let cloudPath = fileSystemPath.join(workingDirectory, localPath);
                let cloudName = fileSystemPath.getFullName(cloudPath);
                let error = descriptor.get('error');

                uploadLog.info({
                    id: descriptor.get('id'),
                    cloudPath,
                });

                error = this._validatePaths({ error, path: localName });
                error = this._validatePaths({ error, path: cloudName });
                error = this._validatePaths({ error, path: cloudPath, onlyPath: true });

                const { fixError, fixCloudName, fixLocalPath, fixCloudPath, hasInvalidCharAutoFix, hasNameTooLongAutoFix } =
                    this._autoFixError({
                        error,
                        cloudName,
                        cloudPath,
                        localPath,
                    });
                error = fixError;
                cloudName = fixCloudName;
                cloudPath = fixCloudPath;
                localPath = fixLocalPath;

                if (error) {
                    attributes.error = error; // TODO: add error for all children recursively
                    attributes.state = UploadDescriptor.STATE_FAIL;
                }

                attributes.hasInvalidCharAutoFix = hasInvalidCharAutoFix;
                attributes.hasNameTooLongAutoFix = hasNameTooLongAutoFix;

                Object.assign(attributes, {
                    cloudName,
                    cloudPath,
                    localPath,
                    visibleName: fileSystemPath.getVisiblePath(cloudName),
                    visiblePath: fileSystemPath.getVisiblePath(cloudPath),
                    nameParts: fileSystemPath.getVisibleNameParts(cloudName),
                    isPublicUpload: IS_PUBLIC,
                    isOwnPublic: IS_OWN_PUBLIC,
                });

                descriptor.set(attributes, {
                    silent: true, // еще не отрисовано
                });

                if (error) {
                    // Такой файл или папка будет сразу отображены с ошибкой.
                    // Чтобы descriptor мог отправить статситику,
                    // сообщаем, что все операции для него закончены.
                    descriptor.finish();
                }

                next(descriptors);
            });
        },

        /**
         * @param {Array.<UploadDescriptor>} descriptors
         */
        _enqueue(descriptors, descriptorOptions = {}) {
            const storage = getCurrentStorage(reduxStore.getState());
            const originalCloudPath = descriptorOptions.originalCloudPath;
            let promise = this._filterDescriptors(descriptors);

            this._conflictResolution = null;
            this._conflictResolutionReadOnlyFolder = null;
            this._folderToUploadFromReactPages = null;

            if (storage === EStorageType.albums) {
                this._setAlbumIdForAlbums(descriptorOptions);
            }

            promise = promise.then((descriptors) => {
                const workingDirectory = getWorkingDirectory(originalCloudPath);

                return this._prepareDescriptors(descriptors, workingDirectory);
            });

            promise = promise.then((descriptors) => {
                if (!descriptors || !descriptors.length) {
                    return;
                }

                sendTmrGoal({ goal: 'upload' });
                sendTmrGoal({ goal: descriptors.length > 1 ? 'upload-few' : 'upload-one' });

                const fileDescriptors = [];

                descriptors.forEach((descriptor) => {
                    const { cloudPath, size, nameParts, id, localPath, error, isDirectory, hasInvalidCharAutoFix, hasNameTooLongAutoFix } =
                        descriptor.attributes;
                    const directoryFolder = isDirectory ? 'folder' : '';
                    const extension = nameParts.extension || directoryFolder;
                    let errorFile = null;

                    switch (true) {
                        case error instanceof NameTooLongFail:
                        case error instanceof PathTooLongFail: {
                            errorFile = { status: EFileStatus.ERROR, error: EFileError.NAME_TOO_LONG };
                            break;
                        }
                        case error instanceof InvalidCharactesFail: {
                            errorFile = { status: EFileStatus.ERROR, error: EFileError.INVALID_CHARACTERS };
                            break;
                        }
                    }

                    if (!errorFile) {
                        if (hasInvalidCharAutoFix) {
                            errorFile = { error: EFileError.INVALID_CHARACTERS_AUTO_FIX };
                        } else if (hasNameTooLongAutoFix) {
                            errorFile = { error: EFileError.NAME_TOO_LONG_AUTO_FIX };
                        }
                    }

                    const storage = getCurrentStorage(reduxStore.getState());
                    if (storage === EStorageType.home && !errorFile) {
                        const workingDirectory = getWorkingDirectory(originalCloudPath);
                        cloudFileSystem.addItemToStore({
                            cloudPath,
                            descriptorId: id,
                            workingDirectory,
                            onlyRedux: true,
                        });
                    }

                    descriptor.getFile().then((file) => {
                        if (!descriptorOptions.continueUpload && file && !IS_PUBLIC) {
                            try {
                                setIndexedDb(cloudPath, file);
                            } catch (error) {
                                sendXray(['uploader', 'idb-keyval', 'setindex', 'error']);
                            }
                        }
                    });

                    descriptor.set('uploadingStorage', storage);

                    fileDescriptors.push({
                        cloudPath,
                        size,
                        name: nameParts.name,
                        extension,
                        descriptorId: id,
                        localPath,
                        hasAutoFix: {
                            hasInvalidCharAutoFix,
                            hasNameTooLongAutoFix,
                        },
                        status: EFileStatus.PROGRESS,
                        ...errorFile,
                        ...descriptorOptions,
                    });

                    if (errorFile) {
                        sendGaUploader('file', errorFile.error);
                        sendGaUploader('testerror', getFileExtLimit(extension));
                    }

                    sendGaUploader(`env-${ENV}`, 'enqueue', {
                        [`file-type-${getFileExtLimit(nameParts.extension)}`]: 1,
                        [`platform-${PLATFORM}`]: 1,
                    });
                });

                reduxStore.dispatch(setInputFilesAction(fileDescriptors));
                reduxStore.dispatch(setProgressStatusAction({ status: EProgressStatus.PROGRESS }));

                sendGaUploader('file', `packet_count-newUploader`, { count: descriptors.length });
                sendGaUploader('file', 'packet');

                if (!this._queue) {
                    this._initQueue();
                }

                this._lastQueuedDescriptors = descriptors;
                this._queue.set(descriptors);
                this._setDataSource();
                this._continueUpload();

                return descriptors;
            });

            promise = promise.catch((error) => {
                showNotification({ text: 'Произошла ошибка' });
                uploadLog.error(error);
            });

            return promise;
        },

        onInputChange(event, descriptorOptions = {}) {
            this._onInputChange(event, descriptorOptions);
        },

        /**
         * @param {jQuery.Event} event
         * @param {object} descriptorOptions - параметры, которые нужно добавить в дескриптор
         */
        _onInputChange(event, descriptorOptions = {}) {
            if (descriptorOptions.continueUpload) {
                this._onUpload(event, descriptorOptions);
                return;
            }

            const input = event.target;
            const files = input.files;

            if (!files?.length) {
                return;
            }

            this._onUpload(files, descriptorOptions);
        },

        /**
         * @param {object} descriptorOptions - параметры, которые нужно добавить в дескриптор
         * @param files - файлы для загрузки
         */
        _onUpload(files, descriptorOptions = {}) {
            const canUpload = this._canUpload();

            if (!canUpload) {
                return;
            }

            reduxStore.dispatch(setHasInputAction(false));
            const state = reduxStore.getState();
            const bttnType = selectButtonTypeClick(state);
            if (!bttnType || bttnType === 'dnd') {
                reduxStore.dispatch(setButtonTypeClickAction('click'));
            }
            const dialogName = getCurrentVisibleDialogId(state);
            if (UPLOAD_DIALOG_ID === dialogName) {
                reduxStore.dispatch(setUploadFromAction('upldlg'));
            }

            let promise;

            if (descriptorOptions.continueUpload) {
                promise = fileSystemFileHelper.getDescriptors([files]);

                uploadLog.info({
                    event: 'input files',
                    details: 1,
                    radarName: 'input-files',
                    radarValue: 1,
                });
            } else {
                promise = fileSystemFileHelper.getDescriptors(files);

                uploadLog.info({
                    event: 'input files',
                    details: files.length,
                    radarName: 'input-files',
                    radarValue: files.length,
                });
            }

            promise = promise.then((descriptors) => {
                this._enqueue(descriptors, descriptorOptions);
                uploadLog.info({
                    event: 'enqueue',
                    details: descriptors.length,
                });
            });

            promise = promise.catch((error) => {
                showNotification({ text: 'Файлы не найдены' });
                uploadLog.error(error);
            });

            return promise;
        },

        onDrop(data, descriptorOptions = {}) {
            this._onDrop(null, data, descriptorOptions);
        },

        /**
         * @param {MicroEvent} event
         * @param {Object} data
         * @param {Array.<FileEntry|DirectoryEntry>} [data.entries]
         * @param {Array.<File>} [data.files]
         */
        _onDrop(event, data, descriptorOptions = {}) {
            const canUpload = this._canUpload();
            const state = reduxStore.getState();

            if (canUpload) {
                const isUploaderOpen = isUploaderVisible(state);
                const dialogName = getCurrentVisibleDialogId(state);
                const folder = getCurrentFolder(state);
                const isWelcomePromo = isWelcomePromoShow(state);
                reduxStore.dispatch(setHasInputAction(false));
                let source = 'upload-area';
                if (isWelcomePromo) {
                    source = 'welcome-upload';
                } else if (UPLOAD_DIALOG_ID === dialogName) {
                    source = 'upldlg';
                } else if (isUploaderOpen) {
                    source = 'uploader';
                } else if (dialogName) {
                    source = dialogName;
                } else if (rPath(['count', 'all'], folder) === 0) {
                    source = 'empty-folder';
                }
                reduxStore.dispatch(setUploadFromAction(source));
                reduxStore.dispatch(setButtonTypeClickAction('dnd'));

                const entries = data.entries;
                let promise;
                const isAccentUploadOpen = getOpenState();

                RADAR.ga('send', 'event', {
                    eventCategory: 'upload',
                    eventAction: 'drop',
                    eventLabel: `accent-upload_${isAccentUploadOpen ? 'open' : 'normal'}`,
                });

                if (UserSelectors.isNewUser(reduxStore.getState())) {
                    sendNewUserGa('upload', 'drop');
                }

                sendDatalistGa('upload');

                if (entries) {
                    promise = fileSystemEntryHelper.getDescriptors(entries);
                    uploadLog.info({
                        event: 'drop entries',
                        details: entries.length,
                        radarName: 'dnd-entries',
                        radarValue: entries.length,
                    });
                } else {
                    const files = data.files;

                    if (files) {
                        promise = fileSystemFileHelper.getDescriptors(files);
                        uploadLog.info({
                            event: 'drop files',
                            details: files.length,
                            radarName: 'dnd-files',
                            radarValue: files.length,
                        });
                    } else {
                        promise = Promise.reject(new Error('not found'));
                    }
                }

                promise = promise.then((descriptors) => {
                    this._enqueue(descriptors, descriptorOptions);
                    uploadLog.info({
                        event: 'enqueue',
                        details: descriptors.length,
                    });
                });

                promise = promise.catch((error) => {
                    showNotification({ text: 'Файлы не найдены' });
                    uploadLog.error(error);
                });

                return promise;
            } else if (IS_PUBLIC) {
                const isAuthorized = app.user.isAuthorized();
                const canUploadToPublic = isPublicUploadEnabled(state);

                if (!isAuthorized && canUploadToPublic) {
                    showNotification({ text: 'Только зарегистрированные пользователи могут загружать файлы в публичные папки.' });
                } else {
                    showNotification({ text: 'Вы можете только просматривать содержимое папки, загружать в нее нельзя' });
                }
            }
        },

        /**
         * @private
         * @param {MicroEvent|jQuery.Event} event
         * @param {Object} data
         */
        handleEvent(event, data) {
            switch (event.type) {
                case DropArea.EVENT_DROP:
                    this._onDrop(event, data);

                    break;

                case 'change':
                    this._onInputChange(event, data);

                    break;

                case 'modifying:update':
                    this._onAppModifyFile(event, data);

                    break;

                case 'modifying:remove':
                    this._onAppRemoveFile(event, data);

                    break;

                case UploadDataSource.EVENT_STATUS:
                    this._onStatus(event, data);

                    break;
            }
        },

        /**
         * @param {UploadDescriptor} descriptor
         * @returns {Promise}
         * @resolves {string} – Путь к файлу или папке (в Unicode NFC) в Облаке.
         * @rejects {UploadReason|Error}
         */
        async _upload(descriptor) {
            let promise;
            const state = descriptor.get('state');
            const workingDirectory = descriptor.get('workingDirectory') || getWorkingDirectory();
            const storage = getCurrentStorage(reduxStore.getState());
            const { isStart, isFavorites, isFeed, isGallery } = getStorage(storage);

            if (
                !(
                    state === UploadDescriptor.STATE_PENDING ||
                    state === UploadDescriptor.STATE_PAUSED ||
                    state === UploadDescriptor.STATE_SUSPENDED
                )
            ) {
                return Promise.reject(new Error('wrong state'));
            }

            const isReadOnly = cloudFileSystem.isReadOnlyDirectory(workingDirectory);

            if (isReadOnly) {
                const stack = new Error('ReadOnlyDirectoryFail');
                const reason = new ReadOnlyDirectoryFail(stack, UploadReason.SOURCE_WEB_CLIENT);

                sendGaUploader('file', 'read_only_directory');
                return Promise.reject(reason);
            }

            const isDirectory = descriptor.get('isDirectory');

            // Даём выбрать папку для загрузки
            if ((isStart || isFavorites || isFeed || isGallery) && descriptor.get('uploadingStorage') !== EStorageType.home) {
                await this._showUploadAnotherFolderDialog(descriptor);
            }

            if (isDirectory) {
                promise = Promise.resolve();
            } else {
                promise = descriptor.upload();
            }

            promise = promise.then(function () {
                const workingDirectory = descriptor.get('workingDirectory') || getWorkingDirectory();

                const promise = descriptor.addToUserCloud(workingDirectory);
                const { extension = '' } = descriptor.get('nameParts');
                const fileSize = descriptor.get('size');
                const startTime = descriptor.get('startTime');
                const wasSuspended = descriptor.get('wasSuspended');

                sendGaUploader(`env-${ENV}`, 'success', {
                    [`file-type-${getFileExtLimit(extension)}`]: 1,
                    [`platform-${PLATFORM}`]: 1,
                });

                if (fileSize >= bigFileSize) {
                    sendGaUploader('successbig');
                }
                if (wasSuspended) {
                    sendGaUploader('successresume');
                }

                const extensionData = extInfo.get(extension);
                sendGaUploader(`ftype`, extensionData ? extensionData.kind : 'unk');

                const group = roundCustom(fileSize, sizeGroups.values, sizeGroups.labels);
                sendGaUploader(`filesize`, group);

                if (startTime) {
                    const uploadTime = Math.round(performance.now() - startTime);
                    sendGaUploader(`time`, null, {
                        ms: uploadTime,
                    });
                    sendGaUploader(group, 'time', {
                        ms: uploadTime,
                    });
                }

                if (IS_PUBLIC) {
                    uploadLog.info({
                        event: 'public-upload-types',
                        details: extension,
                        radarName: `public-upload_type_${getFileExtLimit(extension).toLowerCase()}`,
                    });
                } else {
                    const isAccentUploadOpen = getOpenState();

                    RADAR.ga('send', 'event', {
                        eventCategory: 'upload',
                        eventAction: 'upload-success',
                        eventLabel: `accent-upload_${isAccentUploadOpen ? 'open' : 'normal'}`,
                    });
                }

                return promise;
            });

            return promise;
        },

        _getFirstDescriptorToUpload() {
            if (!this._queue) {
                return null;
            }

            const descriptors = this._queue.filter((descriptor) => {
                const state = descriptor.get('state');
                return state === UploadDescriptor.STATE_PENDING || state === UploadDescriptor.STATE_SUSPENDED;
            });

            return descriptors[0];
        },

        _uploadNext() {
            if (!window.navigator.onLine) {
                return new Promise((resolve) => setTimeout(resolve, RETRY_TIMEOUT)).then(this._uploadNext);
            }

            const descriptor = this._getFirstDescriptorToUpload();

            if (descriptor) {
                this._isActive = true;

                const state = descriptor.get('state');

                if (state === UploadDescriptor.STATE_PENDING || state === UploadDescriptor.STATE_SUSPENDED) {
                    let promise = (
                        state === UploadDescriptor.STATE_SUSPENDED
                            ? new Promise((resolve) => setTimeout(resolve, RETRY_TIMEOUT))
                            : Promise.resolve(true)
                    ).then(() => this._doUploadDescriptor(descriptor));

                    // Здесь важно не создавать замыкание,
                    // чтобы не увеличивать call stack.
                    promise = promise.then(this._uploadNext);

                    return promise;
                }
                // Здесь важно не создавать замыкание,
                // чтобы не увеличивать call stack.
                requestMicrotask().then(this._uploadNext);
            } else {
                this._isActive = false;

                if (!this._dataSource) {
                    // Перед выполненим "cancel all", dataSource уничтожается,
                    // чтобы не реагировать на каждый cancel.
                    this._setDataSource();
                }
            }
        },

        _getUserFilesOverLimit() {
            const limit = app.user.getFileSizeLimit();

            return this._lastQueuedDescriptors.filter((descriptor) => descriptor.get('size') >= limit);
        },

        _skipUserFilesOverLimit() {
            const limit = app.user.getFileSizeLimit();

            this._lastQueuedDescriptors.forEach((descriptor) => {
                const fileSize = descriptor.get('size');

                if (fileSize >= limit) {
                    reduxStore.dispatch(
                        updateUploadFilesAction({
                            descriptorId: descriptor.get('id'),
                            cloudPath: descriptor.get('cloudPath'),
                            status: EFileStatus.ERROR,
                            error: EFileError.CANCELLED_FILE,
                            hideError: true,
                        })
                    );
                    descriptor.cancel();
                }
            });
        },

        _getBiggestFileSizeInQueue() {
            let size = 0;

            if (!this._queue) {
                return size;
            }

            this._queue.forEach((descriptor) => {
                const fileSize = descriptor.get('size');

                if (fileSize > size) {
                    size = fileSize;
                }
            });

            return size;
        },

        _showFileSizeLimitModal({ descriptor, filesOverLimit }) {
            const GB_100 = 1024 ** 3 * 100;
            const fileSize = descriptor.get('size');
            const descriptorId = descriptor.get('id');
            const cloudPath = descriptor.get('cloudPath');

            const getFilesSizeBytes = (filesOverLimit) => {
                const size = filesOverLimit.reduce((resSize, file) => (resSize += file.get('size')), 0);
                return size;
            };

            const getFilesSize = (size) => {
                return bytesToNDigits(size, 3).value;
            };

            if (fileSize > GB_100) {
                RADAR.ga('send', 'event', {
                    eventCategory: 'big-file-dialog',
                    eventAction: 'skip-100-gb',
                });
                descriptor.failPaused();
                reduxStore.dispatch(
                    updateUploadFilesAction({
                        descriptorId,
                        cloudPath,
                        status: EFileStatus.ERROR,
                        error: EFileError.USER_FILE_SIZE_LIMIT_OVER_100_GB,
                    })
                );
                return Promise.resolve();
            }

            let result = {
                file: {
                    extension: descriptor.get('nameParts').extension,
                    name: descriptor.get('cloudName'),
                    size: descriptor.meta('size'),
                    sizeBytes: fileSize,
                },
            };

            if (filesOverLimit.length > 1) {
                const sizeOverLimit = getFilesSizeBytes(filesOverLimit);
                result = {
                    files: {
                        size: getFilesSize(sizeOverLimit),
                        sizeBytes: sizeOverLimit,
                        number: filesOverLimit.length,
                    },
                };
            }

            reduxStore.dispatch(
                updateUploadFilesAction({
                    descriptorId,
                    cloudPath,
                    status: EFileStatus.WARNING,
                    error: EFileError.OVER_QUOTA_LIMIT_DOWNLOAD,
                })
            );

            return new Promise((resolve) => {
                openPopupHelper({
                    popupName: popupNames.UPLOAD_BIG_FILE,
                    data: {
                        ...result,
                        numberOfFiles: this._queue.length,
                        skipFileLoading: () => {
                            sendGaUploader('file', 'over_quota_limit_download');

                            this._skipUserFilesOverLimit(filesOverLimit);
                            resolve();
                        },
                        continueFileLoading: () => {
                            this._doUploadDescriptor(descriptor).then(() => {
                                resolve();
                            });
                        },
                    },
                });
            });
        },

        _doUploadDescriptor(descriptor) {
            let promise = Promise.resolve(descriptor);
            const storage = getCurrentStorage(reduxStore.getState());

            // В альбомах и документах надо создать соответствующие папки перед тем, как начать загружать
            const waitForFolderCreatedName = mapStorageToFolder[storage];

            if (waitForFolderCreatedName) {
                promise = waitForCreateFolderIfNotExists().then(() => descriptor);
                reduxStore.dispatch(uploadDescriptor({ name: waitForFolderCreatedName }));
            }

            promise = promise.then((descriptor) => {
                if (this._conflictResolution && this._conflictResolution !== 'skip') {
                    descriptor.setConflictResolution(this._conflictResolution);
                }

                let promise = this._upload(descriptor);

                promise = promise.catch((error) => {
                    const isExeption = error instanceof Error;
                    const isUploadError = error instanceof UploadError;
                    const isConnectionFail = error instanceof ConnectionFail;
                    const isOverQuotaFail = error instanceof OverQuotaFail;
                    const isFileExistsFail = error instanceof FileExistsFail;
                    const isUserFileSizeLimitFail = error instanceof UserFileSizeLimitFail;
                    const isFileTooLargeError = error instanceof FileTooLargeError;
                    const isReadOnlyDirectoryFail = error instanceof ReadOnlyDirectoryFail;
                    const isPublicFileSizeLimit = error instanceof PublicFileSizeLimitFail;
                    const cloudPath = descriptor.get('cloudPath');
                    const descriptorId = descriptor.get('id');
                    const IS_OWN_PUBLIC = config.get('IS_OWN_PUBLIC');

                    const filesOverLimit = this._getUserFilesOverLimit();

                    const isUserFileSizeLimit = isUserFileSizeLimitFail && !isOverQuotaFail && !(IS_PUBLIC || app.user.isCorp());

                    const isOverQuota =
                        (isPublicFileSizeLimit && IS_OWN_PUBLIC) ||
                        isOverQuotaFail ||
                        ((isFileTooLargeError || isUserFileSizeLimitFail) && !app.user.isPaidUser());

                    let promise = Promise.resolve();

                    if (isExeption || isUploadError || isConnectionFail) {
                        if (isExeption) {
                            // Остальные ошибки уже залогировал descriptor.
                            uploadLog.error(error);
                        }

                        uploadLog.send();
                    }

                    if (isPublicFileSizeLimit && !IS_OWN_PUBLIC) {
                        reduxStore.dispatch(
                            updateUploadFilesAction({
                                descriptorId,
                                cloudPath,
                                status: EFileStatus.ERROR,
                                error: EFileError.OVER_QUOTA_CLOUD_AT_OWNER,
                            })
                        );
                    }

                    if (isUserFileSizeLimit) {
                        promise = promise.then(() => this._showFileSizeLimitModal({ descriptor, filesOverLimit }));
                    } else if (isOverQuota) {
                        sendGaUploader('file', 'over_quota_cloud');

                        const handleAskPayment = (resolve) => (option) => {
                            const isB2bOption = option === 'skip_b2b';

                            if (option === 'skip' || isB2bOption) {
                                descriptor.cancel();

                                sendGaUploader('file', 'skip_over_quota_cloud');

                                if (!isB2bOption) {
                                    reduxStore.dispatch(
                                        updateUploadFilesAction({
                                            descriptorId,
                                            cloudPath,
                                            status: EFileStatus.CANCEL,
                                            error: EFileError.SKIPPED_FILE,
                                            hideError: false,
                                        })
                                    );
                                }

                                resolve();
                            } else {
                                requestPayment({
                                    forceFastCheckout: true,
                                }).then((success) => {
                                    if (success) {
                                        resolve(this._doUploadDescriptor(descriptor));
                                        sendGaUploader('file', 'add_over_quota_cloud');
                                    }
                                });
                            }
                        };

                        promise = promise.then(() => {
                            return new Promise((resolve) => {
                                askUserForPayment(handleAskPayment(resolve));
                                reduxStore.dispatch(
                                    updateUploadFilesAction({
                                        descriptorId,
                                        cloudPath,
                                        status: EFileStatus.WARNING,
                                        error: EFileError.OVER_QUOTA_CLOUD,
                                    })
                                );
                            });
                        });
                    } else if (isFileTooLargeError || isUserFileSizeLimitFail) {
                        descriptor.failPaused();
                        reduxStore.dispatch(
                            updateUploadFilesAction({
                                descriptorId,
                                cloudPath,
                                status: EFileStatus.ERROR,
                                error: EFileError.USER_FILE_SIZE_LIMIT,
                            })
                        );
                    } else if (isFileExistsFail) {
                        sendGaUploader('file', 'file_exist');

                        if (storage === EStorageType.albums) {
                            promise = Promise.resolve({
                                option: 'rename',
                            });
                        } else {
                            promise = promise.then(() => {
                                let promise;
    
                                if (this._conflictResolution !== 'skip') {
                                    promise = askUserForConflict().then((result) => new Promise((resolve) => resolve(result)));
    
                                    const { hasInvalidCharAutoFix, hasNameTooLongAutoFix } = descriptor.attributes;
                                    let errorFile = { status: EFileStatus.WARNING, error: EFileError.FILE_EXIST };
    
                                    if (hasInvalidCharAutoFix) {
                                        errorFile = { status: EFileStatus.INFO, error: EFileError.INVALID_CHARACTERS_AUTO_FIX };
                                    } else if (hasNameTooLongAutoFix) {
                                        errorFile = { status: EFileStatus.INFO, error: EFileError.NAME_TOO_LONG_AUTO_FIX };
                                    }
    
                                    reduxStore.dispatch(
                                        updateUploadFilesAction({
                                            descriptorId,
                                            cloudPath,
                                            ...errorFile,
                                            hideError: false,
                                        })
                                    );
                                } else {
                                    promise = Promise.resolve({
                                        option: 'skip',
                                    });
                                }
    
                                return promise;
                            });
                        }

                        promise = promise.then(({ option, saveForAll }) => {
                            let promise;

                            if (saveForAll) {
                                this._conflictResolution = option;
                            }

                            if (option === 'rewrite' || option === 'rename') {
                                descriptor.setConflictResolution(option);

                                sendGaUploader('file', `${option}_file_exist`);

                                promise = this._doUploadDescriptor(descriptor);
                            } else if (option === 'skip') {
                                sendGaUploader('file', 'skip_file_exist');
                                reduxStore.dispatch(
                                    updateUploadFilesAction({
                                        descriptorId,
                                        cloudPath,
                                        status: EFileStatus.CANCEL,
                                        currentUpload: false,
                                        error: EFileError.FILE_EXIST,
                                        hideError: true,
                                    })
                                );
                                descriptor.cancel();
                                promise = Promise.resolve();
                            }

                            return promise;
                        });
                    } else if (isReadOnlyDirectoryFail) {
                        const savedAnswer = this._conflictResolutionReadOnlyFolder;
                        sendGaUploader('file', 'read_only_folder');

                        reduxStore.dispatch(
                            updateUploadFilesAction({
                                descriptorId,
                                cloudPath,
                                status: EFileStatus.WARNING,
                                error: EFileError.READ_ONLY_DIRECTORY,
                            })
                        );

                        const handleSelectAnotherFolder = (answer) => {
                            let promise;

                            if (answer.action === 'move') {
                                const destination = answer.destination;
                                const newCloudPath = fileSystemPath.join(destination, descriptor.get('localPath'));
                                descriptor.set('cloudPath', newCloudPath);
                                descriptor.set('workingDirectory', destination);

                                promise = this._doUploadDescriptor(descriptor);

                                sendGaUploader('file', 'move_from_ro');
                            } else {
                                sendGaUploader('file', 'skip_from_ro');
                                reduxStore.dispatch(
                                    updateUploadFilesAction({
                                        descriptorId,
                                        status: EFileStatus.CANCEL,
                                        error: EFileError.SKIPPED_FILE,
                                        currentUpload: false,
                                        hideError: true,
                                    })
                                );

                                descriptor.cancel();
                                promise = Promise.resolve();
                            }

                            return promise;
                        };

                        if (!savedAnswer) {
                            promise = promise
                                .then(
                                    () =>
                                        new Promise((resolve, reject) => {
                                            renderSelectAnotherFolderDialog({
                                                forbiddenFolderName: getWorkingDirectory().slice(1), // убираем / в начале
                                                onSuccess: (answer) => {
                                                    const isReadOnly = cloudFileSystem.isReadOnlyDirectory(answer.destination);

                                                    if (isReadOnly) {
                                                        reject();
                                                    } else {
                                                        resolve(answer);
                                                    }
                                                },
                                            });
                                        })
                                )
                                .then((answer) => {
                                    this._conflictResolutionReadOnlyFolder = answer;

                                    return handleSelectAnotherFolder(answer);
                                })
                                .catch(() => {
                                    this._conflictResolutionReadOnlyFolder = null;
                                    promise = this._doUploadDescriptor(descriptor);
                                });
                        } else {
                            promise = handleSelectAnotherFolder(savedAnswer);
                        }
                    } else if (IS_REACT_PAGE) {
                        const state = descriptor.get('state');
                        if (state === UploadDescriptor.STATE_CANCEL) {
                            showNotification({ text: 'Загрузка отменена' });
                        } else {
                            showNotification({ text: 'Ошибка загрузки' });
                        }
                        descriptor.cancel();
                        return promise;
                    }

                    return promise;
                });

                return promise;
            });

            return promise;
        },

        _showUploadAnotherFolderDialog(descriptor) {
            const storage = getCurrentStorage(reduxStore.getState());

            return new Promise((resolve) => {
                if (this._folderToUploadFromReactPages != null) {
                    /**
                     * Необходимо всегда обновлять путь до папки.
                     * Это необходимо при загрузке из галереи и других разделов
                     * */
                    const { destination } = this._folderToUploadFromReactPages;
                    const newCloudPath = fileSystemPath.join(destination, descriptor.get('localPath'));
                    descriptor.set('cloudPath', newCloudPath);
                    descriptor.set('workingDirectory', destination);
                    resolve();
                    return;
                }

                renderSelectUploadFolderDialog({
                    onSuccess: (answer) => {
                        if (answer.action === 'upload') {
                            const { destination } = answer;
                            const newCloudPath = fileSystemPath.join(destination, descriptor.get('localPath'));
                            descriptor.set('cloudPath', newCloudPath);
                            descriptor.set('workingDirectory', destination);

                            sendGaUploader('file', `upload_from_${storage}`);

                            this._folderToUploadFromReactPages = answer;

                            return resolve();
                        }

                        sendGaUploader('file', `skip_from_${storage}`);

                        reduxStore.dispatch(
                            updateUploadFilesAction({
                                descriptorId: descriptor.get('id'),
                                status: EFileStatus.CANCEL,
                                error: EFileError.SKIPPED_FILE,
                                currentUpload: false,
                                hideError: true,
                            })
                        );

                        descriptor.cancel();
                        return resolve();
                    },
                });
            });
        },

        _continueUpload() {
            const isActive = this.isActive();

            if (!isActive) {
                this._uploadNext();
            }
        },

        _initQueue() {
            const queue = new UploadDescriptor.List();

            this._queue = queue;
        },

        _destroyQueue() {
            const queue = this._queue;

            if (queue) {
                queue.destroy();
            }

            this._queue = null;
        },

        _onStatus(event, data) {
            if (data.total) {
                uploaderTotalProgressThrottled({
                    finished: data.finished,
                    failed: data.failed,
                    uploaded: data.uploaded,
                    canceled: data.canceled,
                    inProgress: data.inProgress,
                    progressTotalPercent: data.progress,
                    total: data.total,
                });
                if (!data.inProgress) {
                    if (data.failed) {
                        uploadLog.send();
                    } else {
                        uploadLog.clear();
                        uploadLog.info({
                            event: 'clear log',
                            details: data,
                        });
                    }
                }
            }
        },

        _setDataSource() {
            this._destroyDataSource();

            if (!this._queue) {
                return;
            }

            const dataSource = new UploadDataSource(this._queue);

            this._dataSource = dataSource;

            dataSource.on(UploadDataSource.EVENT_STATUS, this);
            // Если ошибки были обнаружены до создания dataSource,
            // то событие status не произойдет, и ни что не инициирует
            // отправку логов в kaktam.
            dataSource.checkStatus();

            const panel = this._panel;

            if (panel) {
                panel.setDataSource(dataSource);
            }
        },

        _destroyDataSource() {
            const dataSource = this._dataSource;

            if (dataSource) {
                dataSource.off(UploadDataSource.EVENT_STATUS, this);
                dataSource.destroy();
                this._dataSource = null;
            }
        },

        _onSelect(event, data) {
            const descriptor = this._queue.get(data.id);
            const cloudPath = descriptor.get('cloudPath');
            const cloudName = descriptor.get('cloudName');
            const { extension } = descriptor.get('nameParts');

            if (!isNil(extension) && extension === 'pdf') {
                openInNewTab({
                    id: cloudPath,
                    storage: EStorageType.home,
                    name: cloudName,
                });

                return;
            }

            const params = {
                itemId: cloudPath,
                itemStorage: IS_PUBLIC ? EStorageType.public : EStorageType.home,
                gaSuffix: '',
                itemIds: [],
            };
            reduxStore.dispatch(openViewer(params));
        },

        _onPublish(event, data) {
            const descriptor = this._queue.get(data.id);
            const cloudPath = descriptor.get('cloudPath');

            uploadLog.info({
                event: 'publish',
                details: cloudPath,
                radarName: 'publish',
            });

            publishHelper({ item: app.get(cloudPath) });
        },

        _onAppModifyFile(event, file) {
            if (!this._queue) {
                return;
            }

            const descriptors = this._queue.filter((model) => {
                return model.get('cloudPath') === file.id;
            });

            if (descriptors.length) {
                descriptors.each((descriptor) => {
                    descriptor.set('publishStatus', file.publishingStatus);
                });
            }
        },

        _onAppRemoveFile(event, file) {
            const descriptors = this._queue.filter((model) => {
                return model.get('cloudPath') === file.id;
            });

            if (descriptors.length) {
                descriptors.each((descriptor) => {
                    this._queue.remove(descriptor);
                });
            }
        },

        _onCancel(event, data) {
            if (!this._queue) {
                return;
            }

            const descriptor = this._queue.get(data.id);
            const hasCancelableState = descriptor.hasCancelableState();

            if (hasCancelableState) {
                descriptor.cancel();
                sendGaUploader('file', 'cancel');
            }
        },

        _cancelAll() {
            this._destroyDataSource();
            const queue = this._queue;
            let canceled = 0;
            const source = UploadReason.SOURCE_WEB_CLIENT;
            const stack = new Error('UploadCancel');
            const reason = new UploadCancel(stack, source);

            reason.radarName = ''; // prevent radar sent

            for (let i = 0, count = queue.length; i < count; i++) {
                const descriptor = queue[i];
                const hasCancelableState = descriptor.hasCancelableState();

                if (hasCancelableState) {
                    descriptor.cancel(reason);
                    canceled++;
                }
            }

            return {
                canceled,
            };
        },

        _onCancelAll() {
            this._destroyDataSource();
            const cancelInfo = this._cancelAll();

            uploadLog.info({
                event: 'cancel all',
                details: cancelInfo.canceled,
                radarName: 'cancel_web-client_all',
                radarValue: cancelInfo.canceled,
            });
        },

        _onClose() {
            this._destroyQueue();

            uploadLog.info({
                event: 'close',
                radarName: 'close',
            });
        },

        _renderReactDropArea(props = {}) {
            const baseProps = {
                email: app.user.getEmail(),
                setInputs: app.upload.setInputs,
            };

            if (!this.reactDropArea) {
                this.reactDropArea = new UploadDropAreaToolkit();
                this.reactDropArea.render({
                    ...baseProps,
                    ...props,
                });
            } else {
                this.reactDropArea.render({
                    ...baseProps,
                    ...props,
                });
            }
        },

        _destroyReactDropArea() {
            if (this.reactDropArea) {
                this.reactDropArea.destroy();
                this.reactDropArea = null;
            }
        },

        _initDropArea() {
            if (!DropArea.isSupported()) {
                return;
            }

            const target = document;
            const dropArea = new DropArea(target);

            dropArea.on(DropArea.EVENT_DROP, this);

            this._dropArea = dropArea;

            app.on('routeChangeEnd', () => {
                if (!app.user.isFrozen() && !showcaseController.isFolderForShowcase(app.folder() && app.getStorage() !== 'recommend')) {
                    if (this.reactDropArea) {
                        return;
                    }

                    if (app.user.isNewbie()) {
                        reduxStore.dispatch(hideUploaderAction());
                    }

                    if (!IS_PHONE) {
                        this._renderReactDropArea();
                    }
                } else {
                    this._destroyReactDropArea();
                }
            });
        },

        /**
         * Загрузка через ctrl+v
         */
        _initClipboardUpload() {
            document.addEventListener('paste', async (e) => {
                const files = Object.values(e.clipboardData?.files);
                // если сделать preventDefault раньше, то перестанет работать событие paste

                if (files?.length) {
                    e.preventDefault();
                    sendGaUploader('clipboard', 'upload');
                    reduxStore.dispatch(setUploadFromAction('clipboard'));
                    reduxStore.dispatch(setButtonTypeClickAction('clipboard'));

                    renderUploadFromClipboardDialog({
                        onActionClick: () => this._onUpload(files),
                        files,
                    });
                }
            });
        },

        _destroyDropArea() {
            const dropArea = this._dropArea;

            if (dropArea) {
                dropArea.off(DropArea.EVENT_DROP, this);
                dropArea.destroy();

                this._dropArea = null;
            }
        },

        dropArea() {
            return this._dropArea;
        },

        destroy() {
            this._destroyDataSource();
            this._destroyQueue();
            this._destroyDropArea();

            this.handleEvent = null;
            this._uploadNext = null;
        },
    };

    module.exports = UploadController;
});
